import { EquipmentModelData } from "@/features/equipments/types/equipments.type";
import { Car } from "lucide-react";

export class EquipmentModelsTransformer {
  static optionsTransformer() {
    return (equipmentModels: EquipmentModelData[]) => {
      return equipmentModels.map((equipmentModel) => {
        return {
          value: equipmentModel.id,
          label: equipmentModel.display_name,
          icon: <Car strokeWidth={1} size={20} />
        };
      });
    };
  }
}
